var _circle, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyprofile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5970279,
    cx: 35.4863,
    cy: 35.6047,
    r: 34.5,
    stroke: "white",
    fillOpacity: 0.20648,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1517 36.5099C35.2098 36.5099 35.2698 36.509 35.3289 36.507C35.3821 36.508 35.4344 36.509 35.4876 36.509C38.802 36.509 41.2133 33.5856 41.1852 30.6497C41.1552 27.5435 38.6046 24.8108 35.3202 24.8108V26.7468C37.4294 26.7468 39.2289 28.5434 39.2492 30.6691C39.2589 31.6661 38.8175 32.7135 38.0693 33.4695C37.5708 33.9728 36.718 34.573 35.4876 34.573L35.3831 34.572L35.325 34.5701L35.2679 34.572L35.1517 34.5739C32.9457 34.5739 31.3998 32.5499 31.3931 30.7339C31.3834 28.5889 33.1683 26.7633 35.2892 26.7468L35.3202 24.8108H35.2747C32.0019 24.835 29.4445 27.5851 29.4571 30.7427C29.4677 33.6205 31.8703 36.5099 35.1517 36.5099Z",
    id: "mask-fill-icon"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 36,
    width: 23,
    height: 9
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2852 36.8002H46.3599V44.9003H24.2852V36.8002Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2231 44.9004C26.4002 42.4146 27.9035 39.8688 30.8704 38.8814C32.3214 39.6442 33.8111 40.0294 35.3115 40.0294C36.8109 40.0294 38.3074 39.6432 39.772 38.8814C42.039 39.6209 44.1434 41.677 44.4174 44.9004H46.3601C46.0591 40.4302 42.9296 37.5311 39.5048 36.8089C38.1109 37.6637 36.7093 38.0935 35.3115 38.0935C33.9128 38.0935 32.516 37.6637 31.1298 36.8002C26.9684 37.7673 24.4865 41.2326 24.2852 44.9004H26.2231Z",
    id: "mask-fill-icon"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyprofile);
export default __webpack_public_path__ + "static/media/myprofile.2d9e0e216a85e5116f591deb9e3cecae.svg";
export { ForwardRef as ReactComponent };